import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../utils/axios'


const initialState = {
    data: [],
    status: 'idle',
};

export const getStuffs = createAsyncThunk('/stuffs/get', async () => {

    let res = axios.get('stuffs',{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data);

      return data.data.data.Stuffs


    
})

export const createStuff = createAsyncThunk('/stuffs/create', async (item) => {

  let res = axios.post('stuffs', item,{
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }).catch((err)=>{
      console.log(err)
      // setError(err.response.data.message)
    })
    
    
    const data = await res
    // console.log(data);
    if(data.data.success){
      alert('Stuff yaratildi')
    }

    // return data.data.data.News


  
})
export const deleteStuff = createAsyncThunk('/stuffs/delete', async (id) => {

  let res = axios.delete(`stuffs/${id}`,{
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }).catch((err)=>{
      console.log(err)
      // setError(err.response.data.message)
    })
    
    
    const data = await res
    console.log(data);
    if(data.data.success){
      alert("Stuff o'chirildi")
    }

    // return data.data.data.News


  
})

export const editStuff = createAsyncThunk('/stuffs/edit', async (item) => {

  let res = axios.put(`stuffs/${item._id}`, item.formData,{
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }).catch((err)=>{
      console.log(err)
      // setError(err.response.data.message)
    })
    
    
    const data = await res
    console.log(data);
    if(data.data.success){
      alert("Stuff o'zgartirildi")
    }

    // return data.data.data.News


  
})

const stuffs = createSlice({
    name: 'stuffs',
    initialState,
    reducers: {},
    extraReducers(builder) {
      builder
      .addCase(getStuffs.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(getStuffs.rejected, (state, action) => {
        state.status = 'failed'
      })
      .addCase(getStuffs.fulfilled,(state, action) => {
        // state.status = "idle";
        state.data = action.payload;
        state.status = 'succeeded'
      })
      .addCase(createStuff.fulfilled,(state, action) => {
        // state.status = "idle";
        state.status = 'idle'
      })
      .addCase(deleteStuff.fulfilled,(state, action) => {
        // state.status = "idle";
        state.status = 'idle'
      })
      .addCase(editStuff.fulfilled,(state, action) => {
        // state.status = "idle";
        state.status = 'idle'
      })
      }
  });
export const reducer = stuffs.reducer;